import { isAccount } from '../resources/istatement/account';
export class Account {
    homePage;
    name;
    constructor(cfg = {}) {
        this.homePage = cfg.homePage;
        this.name = cfg.name;
    }
    asVersion(version = '1.0.3') {
        const { homePage, name } = this;
        return { homePage, name };
    }
    toString() {
        if (this.homePage) {
            return this.homePage;
        }
        if (this.name) {
            return this.name;
        }
        return '';
    }
}
export class Agent {
    objectType = 'Agent';
    name;
    mbox;
    mbox_sha1sum;
    openid;
    account;
    degraded;
    constructor(cfg) {
        this.degraded = false;
        this.init(cfg);
    }
    init(cfg = {}) {
        const directProps = ['name', 'mbox', 'mbox_sha1sum', 'openid'];
        if (typeof cfg.lastName !== 'undefined' || typeof cfg.firstName !== 'undefined') {
            cfg.name = '';
            if (typeof cfg.firstName !== 'undefined' && cfg.firstName.length > 0) {
                cfg.name = cfg.firstName[0];
                if (cfg.firstName.length > 1) {
                    this.degraded = true;
                }
            }
            if (cfg.name !== '') {
                cfg.name += ' ';
            }
            if (typeof cfg.lastName !== 'undefined' && cfg.lastName.length > 0) {
                cfg.name += cfg.lastName[0];
                if (cfg.lastName.length > 1) {
                    this.degraded = true;
                }
            }
        }
        else if (typeof cfg.familyName !== 'undefined' || typeof cfg.givenName !== 'undefined') {
            cfg.name = '';
            if (typeof cfg.givenName !== 'undefined' && cfg.givenName.length > 0) {
                cfg.name = cfg.givenName[0];
                if (cfg.givenName.length > 1) {
                    this.degraded = true;
                }
            }
            if (cfg.name !== '') {
                cfg.name += ' ';
            }
            if (typeof cfg.familyName !== 'undefined' && cfg.familyName.length > 0) {
                cfg.name += cfg.familyName[0];
                if (cfg.familyName.length > 1) {
                    this.degraded = true;
                }
            }
        }
        if (cfg.account && isAccount(cfg.account)) {
            if (cfg.account instanceof Account) {
                this.account = cfg.account;
            }
            else {
                this.account = new Account(cfg.account);
            }
        }
        for (const prop of directProps) {
            if (cfg[prop]) {
                let val = cfg[prop];
                if (prop === 'mbox' && !val.startsWith('mailto:')) {
                    val = `mailto:${val}`;
                }
                this[prop] = val;
            }
        }
    }
    toString(lang) {
        if (this.name) {
            return this.name;
        }
        if (this.mbox) {
            return this.mbox.replace('mailto:', '');
        }
        if (this.mbox_sha1sum) {
            return this.mbox_sha1sum;
        }
        if (this.openid) {
            return this.openid;
        }
        if (this.account) {
            return this.account.toString();
        }
        return `${this.objectType}: unidentified`;
    }
    asVersion(version = '1.0.3') {
        const { objectType, mbox, mbox_sha1sum, openid, name } = this;
        const result = {
            objectType,
            name,
            mbox,
            mbox_sha1sum,
            openid
        };
        if (this.account) {
            result.account = this.account.asVersion(version);
        }
        return result;
    }
    static fromJSON(agentJSON) {
        const _agent = JSON.parse(agentJSON);
        return new Agent(_agent);
    }
}
